module.exports = __webpack_public_path__ + "media/stylesheets/images/staff/hero-pc-0efff07a42482eaf19386405b16a6a90.png";